const selectors = { button: "button.copy-text-button" };

export default selectors;
